export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const SET_USER_DATA = 'SET_USER_DATA';
export const USER_WAX_BALANCE = 'USER_WAX_BALANCE';
export const USER_RTP_BALANCE = 'USER_RTP_BALANCE';
export const USER_ITEMS = 'USER_ITEMS';
export const USER_STAKED_ITEMS = 'USER_STAKED_ITEMS';

export const USER_STAKED_TOOLS = 'USER_STAKED_TOOLS';
export const USER_RESOURCES = 'USER_RESOURCES';
export const USER_PROBABILITY_GET_POINTS = 'USER_PROBABILITY_GET_POINTS';
export const SP_CONFIG = 'SP_CONFIG';
export const TOTAL_SP = 'TOTAL_SP';
export const USER_ERA = 'USER_ERA';
export const DELPHI_ORACLE_COURSE = 'DELPHI_ORACLE_COURSE';

export const TOOL_CONFIG = 'TOOL_CONFIG';
export const WP_CONFIG = 'WP_CONFIG';
export const POOL_CONFIG = 'POOL_CONFIG';
